// actions
export const ACTION_PUBLISH = 'publish'
export const ACTION_UNPUBLISH = 'unpublish'

// statuses
export const STATUS_PUBLISHED = 'published'
export const STATUS_DRAFT = 'draft'

// labels
export const DATE_CREATED_LABEL = 'dateCreated'
export const DATE_UPDATED_LABEL = 'dateUpdated'
export const CREATED_BY_LABEL = 'createdBy'
export const MODIFIED_BY_LABEL = 'modifiedBy'
export const STATUS_LABEL = 'status'
export const PUBLISHED_LABEL = 'published'
export const DRAFT_LABEL = 'draft'

// filter types
export const FILTER_TYPE_DATE_CREATED = 'date_created'
export const FILTER_TYPE_DATE_CREATED_FROM = `${FILTER_TYPE_DATE_CREATED}_from`
export const FILTER_TYPE_DATE_CREATED_TO = `${FILTER_TYPE_DATE_CREATED}_to`
export const FILTER_TYPE_DATE_UPDATED = 'date_updated'
export const FILTER_TYPE_DATE_UPDATED_FROM = `${FILTER_TYPE_DATE_UPDATED}_from`
export const FILTER_TYPE_DATE_UPDATED_TO = `${FILTER_TYPE_DATE_UPDATED}_to`
export const FILTER_TYPE_CREATED_BY = 'created_by'
export const FILTER_TYPE_MODIFIED_BY = 'modified_by'
export const FILTER_TYPE_STATUS = 'status'

export const LOOKUP_TABLES_FILTERS = [
  {
    label: DATE_CREATED_LABEL,
    value: FILTER_TYPE_DATE_CREATED,
  },
  {
    label: DATE_UPDATED_LABEL,
    value: FILTER_TYPE_DATE_UPDATED,
  },
  {
    label: CREATED_BY_LABEL,
    value: FILTER_TYPE_CREATED_BY,
  },
  {
    label: MODIFIED_BY_LABEL,
    value: FILTER_TYPE_MODIFIED_BY,
  },
  {
    label: STATUS_LABEL,
    value: FILTER_TYPE_STATUS,
  },
]

export const LOOKUP_TABLES_STATUS_FILTER = [
  {
    label: PUBLISHED_LABEL,
    value: STATUS_PUBLISHED,
  },
  {
    label: DRAFT_LABEL,
    value: STATUS_DRAFT,
  },
]
